{
    "coordinates": [
        45.60038521250078,
        11.222187644407711
    ],
    "tooltip": "Bolca",
    "title": "Pesciara (Monte Bolca)",
    "country": "Italy",
    "period": "Paleogene",
    "alt": "TODO"
}
